module.exports = __webpack_public_path__ + "static/fonts/Mont-BoldItalic.a81daea.woff";